// Regex de validación de email del estándar HTML5 (WHATWG) — el mismo criterio que
// aplica <input type="email">. Los cuantificadores están acotados ({0,61}) y el patrón
// está anclado, por lo que no hay riesgo de ReDoS (S5852).
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

/**
 * Valida un email. Devuelve el mensaje de error o `null` si es válido.
 * - Vacío: error solo si es requerido.
 * - Con valor: debe cumplir el formato del estándar HTML5.
 */
export const validarEmail = (value: string, required: boolean): string | null => {
  const v = value.trim();
  if (!v) return required ? 'Campo requerido' : null;
  return EMAIL_REGEX.test(v) ? null : 'Email inválido';
};
